import React from 'react'
import Link from 'gatsby-link'

import styles from './Header.module.css'

// image
import logo from '../images/logo/AK-Burgenland-Logo.png'

class Header extends React.Component {
  frontPage() {
    return (
      <div className={styles.head}>
        <a href="https://bgld.arbeiterkammer.at/index.html">
          <img src={logo} className={styles.logo} />
        </a>
        <div className={styles.text}>
          <h1>
            <Link to="/">Kinderbetreuungsatlas Burgenland</Link>
          </h1>
        </div>
      </div>
    )
  }

  contentPage() {
    return (
      <div className={styles.content}>
        <a href="https://bgld.arbeiterkammer.at/index.html">
          <img src={logo} className={styles.logo} />
        </a>
        <div className={styles.text_content}>
          <h1>
            <Link to="/">Kinderbetreuungsatlas Burgenland</Link>
          </h1>
        </div>
      </div>
    )
  }

  render() {
    return this.props.isHomepage ? this.frontPage() : this.contentPage()
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/layouts/Header.js